<script setup>
import {ref, onBeforeMount, reactive, nextTick} from 'vue';
import YTCreateAdv from "./components/create/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {addAdvertisement, detailAdvertisement, editAdvertisement} from "@/api/advertisement/advertisement.js";
import {ElMessage} from "element-plus";
import router from "@/router/index.js";
import {listAdvertisementReviewLog} from "@/api/advertisementReviewLog/advertisementReviewLog.js";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)

onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.advertisementId)
  if (isEdit.value) {
    await getDetail(route.query.advertisementId)
    await handleGetAdvLog(route.query.advertisementId)
  }
})

// 广告日志列表
const listAdvLog = ref([])
// 处理获取广告审批日志
const handleGetAdvLog = async (id) => {
  try {
    loading.value = true
    listAdvLog.value = await listAdvertisementReviewLog(id)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 加载状态
const loading = ref(false)
// 创建广告
const createAdv = async (param) => {
  try {
    loading.value = true
    if (isEdit.value) {
      await editAdvertisement(param)
    } else {
      await addAdvertisement(param)
    }
    ElMessage.success(isEdit.value ? '编辑成功' : '创建成功')
    router.push({ path: '/listAdvertisements' })
    console.log("param", param)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 表单信息
const ruleForm = reactive({
  advertisementId: null,
  advertisementName: null,
  advertisementNameEn: null,
  advertisementType: "BANNER",
  positionId: null,
  sort: null,
  onlineTime: null,
  offlineTime: null,
  effectiveValue: null,
  effectiveType: null,
  coverImage: null,
  advDesc: null,
  linkType: null,
  linkValue: null,
  advLog: []
})
// 创建广告组件锚点
const YTCreateAdvRef = ref()
// 获取广告详情
const getDetail = async (id) => {
  try {
    loading.value = true
    let param = {
      id: id
    }
    const res = await detailAdvertisement(id)
    // const res = {
    //   advertisementName: "测试广告",
    //   advertisementNameEn: "test Adv",
    //   positionId: "1",
    //   sort: "1",
    //   onlineTime: "2025-10-23",
    //   offlineTime: "2025-10-25",
    //   effectiveValue: "3",
    //   effectiveType: "DAY",
    //   coverImage: 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/test/permanent_img_file/101/user/avatar/b4e72fe3af4c4a9c9c849142d115d5ed.jpg',
    //   details: "testTest112233",
    //   details_en: "testTest112233",
    //   urlType: "INNER",
    //   url: "testLink123456",
    //   advLog: [
    //     {
    //       reviewLogId: "1",
    //       advertisementId: "1",
    //       reviewerId: "1",
    //       reviewerName: "莱卡恩",
    //       state: "APPROVED",
    //       crTime: "2025-10-23 16:00:00",
    //       remark: "好好好"
    //     },
    //     {
    //       reviewLogId: "1",
    //       advertisementId: "1",
    //       reviewerId: "1",
    //       reviewerName: "圆鲨鲨",
    //       state: "PENDING_REVIEW",
    //       crTime: "2025-10-23 15:00:00",
    //       remark: "好好好"
    //     },
    //     {
    //       reviewLogId: "1",
    //       advertisementId: "1",
    //       reviewerId: "1",
    //       reviewerName: "莱卡恩",
    //       state: "REJECTED",
    //       crTime: "2025-10-23 14:00:00",
    //       remark: "不不不"
    //     },
    //     {
    //       reviewLogId: "1",
    //       advertisementId: "1",
    //       reviewerId: "1",
    //       reviewerName: "圆鲨鲨",
    //       state: "PENDING_REVIEW",
    //       crTime: "2025-10-23 13:00:00",
    //       remark: ""
    //     },
    //   ]
    // }
    Object.assign(ruleForm, res)
    console.log("ruleForm", ruleForm)
    console.log("YTCreateAdvRef.value", YTCreateAdvRef.value)
    nextTick(() => {
      YTCreateAdvRef.value.handleReview(ruleForm)
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <YTCreateAdv ref="YTCreateAdvRef" :readOnly="true" :listAdvLog="listAdvLog" @submit="createAdv" :loading="loading" @update:loading="val => loading = val"></YTCreateAdv>
    </v-container>
  </div>
</template>

<style scoped>

</style>
